import Vue from "vue"
import Vuex from 'vuex'
import VueRouter from "vue-router"
import axios from 'axios'
import moment from 'moment'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faHome} from '@fortawesome/free-solid-svg-icons';
import {faJs, faVuejs} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import IdleVue from 'idle-vue'
import VueProgressBar from 'vue-progressbar';
import VueNumeric from 'vue-numeric'
import Vue2Filters from 'vue2-filters'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueClipboard from "vue-clipboard2";
import rate from 'vue-rate'
import 'vue-rate/dist/vue-rate.css'
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.css";
import 'tinymce/themes/silver/theme';

import Editor from "@tinymce/tinymce-vue";

Vue.component('Editor', Editor);

Vue.use(rate)


require('moment/locale/es');
require('animate.css');
require('normalize.css');

require('@fortawesome/fontawesome-free/css/all.min.css');
// Custom CSS and JS
require('../css/app.css');
require('./utils/filters.js');
// Idle
const eventsHub = new Vue();
library.add(faHome, faJs, faVuejs);
window.CryptoJS = require("crypto-js");
window.versionApp = document.querySelector('meta[name="app-version"]').getAttribute('content');
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(ElementUI, {locale});
Vue.use(require('vue-moment'), {moment});
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 15/*Minutes*/ * 60/*Seconds*/ * 1000/*Miliseconds*/
});
Vue.use(VueProgressBar, {
    color: '#2cbb44',
    failedColor: '#fbbd08',
    height: '10px'
});
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard);
Vue.use(VueVideoPlayer)

window.$ = window.jQuery = require('jquery');

Vue.use(Vue2Filters);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueNumeric);
window.Vue = Vue;
window.axios = axios;
window.moment = moment;
window._ = require('lodash');


window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Accept-C': window.acceptC
};

if (window.sessionStorage.getItem('acquisition_token')) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' +
        window.sessionStorage.getItem('acquisition_token');
}
